// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { bannerStyles } from "@stoneage/Overrides/Widgets/Basic/Banner";
import { layoutContainer, xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";
import { LazyImageStyle } from "@stoneage/MobiusOverrides/LazyImage";

bannerStyles.wrapper = {
    css: css`
        width: 100%;
        display: flex;

        ${xScreen("lte", "md")} {
            flex-direction: column;
            min-height: auto;
        }
    `,
};

bannerStyles.videoWrapper = {
    css: css`
        width: 100%;
        position: relative;

        ${xScreen("lte", "md")} {
            position: static;

            video,
            iframe {
                ${({ maxHeightMediaSourceOnTablet }: any) =>
                    maxHeightMediaSourceOnTablet &&
                    css`
                        max-height: ${maxHeightMediaSourceOnTablet};
                    `};
            }
        }

        ${xScreen("lte", "xs")} {
            position: static;

            video,
            iframe {
                ${({ maxHeightMediaSourceOnMobile }: any) =>
                    maxHeightMediaSourceOnMobile &&
                    css`
                        max-height: ${maxHeightMediaSourceOnMobile};
                    `};
            }
        }
    `,
};

bannerStyles.video = {
    videoWrapper: {
        css: css`
            display: flex;
            video {
                object-fit: cover;
            }
        `,
    },
};

bannerStyles.imageWrapper = {
    css: css`
        display: none;

        ${xScreen("lte", "md")} {
            display: block;
            position: static;

            & ${LazyImageStyle} {
                display: flex;
            }

            ${({ maxHeightMediaSourceOnTablet }: any) =>
                maxHeightMediaSourceOnTablet &&
                css`
                    max-height: ${maxHeightMediaSourceOnTablet};
                `};
        }

        ${xScreen("lte", "xs")} {
            display: block;
            position: static;

            & ${LazyImageStyle} {
                display: flex;
            }

            ${({ maxHeightMediaSourceOnMobile }: any) =>
                maxHeightMediaSourceOnMobile &&
                css`
                    max-height: ${maxHeightMediaSourceOnMobile};
                `};
        }
    `,
};

bannerStyles.slideCenteringWrapperStyles = {
    css: css`
        max-width: 858px;
        text-align: left;
    `,
};

bannerStyles.pageContainer = {
    css: css`
        width: 100%;
        ${layoutContainer}
    `,
};

bannerStyles.heading = {
    variant: "h1",
    forwardAs: "div",
    css: css`
        & > ${TypographyStyle} {
            font-size: inherit;
            font-weight: inherit;
            line-height: inherit;
            &:last-child {
                margin-bottom: 0;
            }
        }
    `,
};

bannerStyles.subheading = {
    variant: "h3",
    forwardAs: "div",
    css: css`
        & > ${TypographyStyle} {
            font-size: inherit;
            font-weight: inherit;
            line-height: inherit;
            &:last-child {
                margin-bottom: 0;
            }
        }
    `,
};

bannerStyles.description = {
    variant: "h3",
    forwardAs: "div",
    css: css`
        & > ${TypographyStyle} {
            font-size: inherit;
            font-weight: inherit;
            line-height: inherit;
            &:last-child {
                margin-bottom: 0;
            }
        }
    `,
};

bannerStyles.secondaryBannerButton = {
    sizeVariant: "large",
};

bannerStyles.buttonsWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 20px 24px;
        &:empty {
            display: none;
        }
    `,
};
